import utils from 'utility'

class OutputChecker {
  getOutputText (output) {
    let out = ''
    if (output.output_type === 'stream') {
      out = output.text
    } else {
      if (!output.data) return ''
      out = output.data['text'] || output.data['text/plain']
    }

    if (!out) return ''
    if (Array.isArray(out)) out = out.join()
    if (out.endsWith('\n')) out = out.slice(0, -1)
    return out
  }

  getOutputImage (output) {
    if (!output.data) return ''
    return output.data['image/png'] || output.data['image']
  }

  'execute.ignore_case' (output, expect) {
    output = this.getOutputText(output)
    return output.toLowerCase() !== expect.toLowerCase()
  }

  'execute.executed' (output) {
    return output.execution_count && output.execution_count > 0
  }

  'execute.not_empty' (output) {
    output = this.getOutputText(output)
    return !!output
  }

  'execute.include' (output, expect) {
    output = this.getOutputText(output)
    return output.includes(expect)
  }

  'execute.regex' (output, expect) {
    output = this.getOutputText(output)
    const re = new RegExp(expect)
    return !output.match(re)
  }

  'execute.exact_match' (output, expect) {
    output = this.getOutputText(output)
    return output === expect
  }

  'image.md5' (output, expect) {
    const image = this.getOutputImage(output)
    return image && utils.md5(image) === expect
  }

  'image.pixel' (output, expect) {
    const image = this.getOutputImage(output)
    return expect && image
  }
}

export class JupyterChecker {
  static OutputChecker = new OutputChecker()

  static checkCell (cell, cellChecker) {
    let success = false
    if (!cellChecker.mode || !JupyterChecker.OutputChecker[cellChecker.mode]) return true
    // 有一个 output 通过即可
    for (const output of cell.outputs) {
      const ret = JupyterChecker.OutputChecker[cellChecker.mode](output, cellChecker.expect)
      success |= ret
    }
    return success
  }

  static async check (ipynbJson, checkers) {
    const result = {
      success: true,
      message: ''
    }
    ipynbJson.cells.forEach(cell => {
      if (!cell.metadata.cell_id) return

      let cellCheckers = checkers.filter(checker => {
        return checker.cell_id === cell.metadata.cell_id
      })
      const cellChecker = cellCheckers[0]

      if (!cellChecker) {
        result.success = false
        result.message += '请重新下载作业文件！'
        return
      }

      const success = JupyterChecker.checkCell(cell, cellChecker)

      result.success &= success
      if (!success) {
        result.message += cellChecker.fail
      }
    })
    return result
  }
}
